<div class="alerts-registry-container">
  <p-toast position="top-right" />

  <!-- Breadcrumb -->
  <nav class="mb-4" aria-label="Breadcrumb">
    <p-breadcrumb
      styleClass="custom-breadcrumb"
      [model]="breadcrumbItems"
      [home]="{icon: 'pi pi-home', routerLink: '/axa/professionals-dashboard'}">
    </p-breadcrumb>
  </nav>

  <!-- Page Header -->
  <div class="header-row mb-4">
    <h1 class="page-title">
      <i class="pi pi-bell mr-2" aria-hidden="true"></i>
      Avvisi
    </h1>
  </div>

  <!-- Tabella riutilizzabile -->
  <app-registry-table
    title="Avvisi"
    icon="pi-bell"
    [columns]="columns"
    [data]="tableData()"
    [loading]="loading()"
    [ignoreStatusChecks]="true"
    emptyStateTitle="Nessun avviso trovato"
    emptyStateMessage="Non ci sono avvisi da visualizzare."
    [customActionsTemplate]="alertActions">
  </app-registry-table>

  <!-- Template azioni custom per ogni riga -->
  <ng-template #alertActions let-alert>
    <div class="flex gap-1 align-items-center">

      <!-- Visualizza fiduciario -->
      <p-button
        icon="pi pi-eye"
        [text]="true"
        [rounded]="true"
        severity="secondary"
        pTooltip="Visualizza fiduciario"
        tooltipPosition="top"
        (onClick)="goToQuestionnaire(alert)">
      </p-button>

      <!-- Prendi in carico (solo UNREAD) -->
      @if (alert.alertStatus === 'UNREAD') {
        <p-button
          icon="pi pi-inbox"
          [text]="true"
          [rounded]="true"
          severity="warn"
          pTooltip="Prendi in carico"
          tooltipPosition="top"
          (onClick)="takeInCharge(alert)">
        </p-button>
      }

      <!-- Risolvi (UNREAD o IN_PROGRESS) -->
      @if (alert.alertStatus !== 'RESOLVED') {
        <p-button
          icon="pi pi-check"
          [text]="true"
          [rounded]="true"
          severity="success"
          pTooltip="Risolvi"
          tooltipPosition="top"
          (onClick)="resolve(alert)">
        </p-button>
      }

    </div>
  </ng-template>

</div>
